import { render, staticRenderFns } from "./dialog_detail.vue?vue&type=template&id=05d54c24&scoped=true&"
import script from "./dialog_detail.vue?vue&type=script&lang=js&"
export * from "./dialog_detail.vue?vue&type=script&lang=js&"
import style0 from "./dialog_detail.vue?vue&type=style&index=0&id=05d54c24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d54c24",
  null
  
)

export default component.exports